"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomLoggerWrapper = void 0;
var shared_utils_1 = require("@d-fischer/shared-utils");
var getMinLogLevelFromEnv_1 = require("./getMinLogLevelFromEnv");
var LogLevel_1 = require("./LogLevel");
var CustomLoggerWrapper = /** @class */ (function () {
    function CustomLoggerWrapper(_a) {
        var name = _a.name, minLevel = _a.minLevel, custom = _a.custom;
        var _b;
        this._minLevel = (_b = shared_utils_1.mapOptional(minLevel, function (lv) { return LogLevel_1.resolveLogLevel(lv); })) !== null && _b !== void 0 ? _b : getMinLogLevelFromEnv_1.getMinLogLevelFromEnv(name);
        this._override = typeof custom === 'function' ? { log: custom } : custom;
    }
    CustomLoggerWrapper.prototype.log = function (level, message) {
        if (this._shouldLog(level)) {
            this._override.log(level, message);
        }
    };
    CustomLoggerWrapper.prototype.crit = function (message) {
        if (!this._override.crit) {
            this.log(LogLevel_1.LogLevel.CRITICAL, message);
        }
        else if (this._shouldLog(LogLevel_1.LogLevel.CRITICAL)) {
            this._override.crit(message);
        }
    };
    CustomLoggerWrapper.prototype.error = function (message) {
        if (!this._override.error) {
            this.log(LogLevel_1.LogLevel.ERROR, message);
        }
        else if (this._shouldLog(LogLevel_1.LogLevel.ERROR)) {
            this._override.error(message);
        }
    };
    CustomLoggerWrapper.prototype.warn = function (message) {
        if (!this._override.warn) {
            this.log(LogLevel_1.LogLevel.WARNING, message);
        }
        else if (this._shouldLog(LogLevel_1.LogLevel.WARNING)) {
            this._override.warn(message);
        }
    };
    CustomLoggerWrapper.prototype.info = function (message) {
        if (!this._override.info) {
            this.log(LogLevel_1.LogLevel.INFO, message);
        }
        else if (this._shouldLog(LogLevel_1.LogLevel.INFO)) {
            this._override.info(message);
        }
    };
    CustomLoggerWrapper.prototype.debug = function (message) {
        if (!this._override.debug) {
            this.log(LogLevel_1.LogLevel.DEBUG, message);
        }
        else if (this._shouldLog(LogLevel_1.LogLevel.DEBUG)) {
            this._override.debug(message);
        }
    };
    CustomLoggerWrapper.prototype.trace = function (message) {
        if (!this._override.trace) {
            this.log(LogLevel_1.LogLevel.TRACE, message);
        }
        else if (this._shouldLog(LogLevel_1.LogLevel.TRACE)) {
            this._override.trace(message);
        }
    };
    CustomLoggerWrapper.prototype._shouldLog = function (level) {
        return this._minLevel === undefined || this._minLevel >= level;
    };
    return CustomLoggerWrapper;
}());
exports.CustomLoggerWrapper = CustomLoggerWrapper;
//# sourceMappingURL=CustomLoggerWrapper.js.map